import axios from "axios";

export default {

  data: () => ({
    payments: [],
    page: 1,
    pages: 0,

    // search
    company: "",
    user: "",
    authority: "",
    min_date: "",
    max_date: "",
    pay_type: "",
    status: "",

    // selects
    statuses: [
      { text: 'نامعلوم', value: 0 },
      { text: 'لغو', value: 1 },
      { text: 'موفق', value: 2 },
    ],
    types: [
      { text: 'ثبت شخص / شرکت', value: 1 },
      { text: 'پشتیبانی', value: 2 },
    ],
  }),

  mounted() {
    this.get_payments()
  },

  methods: {
    async get_payments() {
      console.log(this.status);
      console.log(this.pay_type.value);
      console.log(this.user);
      this.$store.commit('progress_status', true)
      await axios({
        method: "GET",
        url: "/payments",
        headers: {
          token: sessionStorage.getItem("token")
        },
        params: {
          page: this.page,
          company: this.company,
          user: this.user,
          authority: this.authority,
          minDate: this.min_date,
          maxDate: this.max_date,
          payType: this.pay_type.value,
          status: this.status.value,

        }
      })
        .then((res) => {
          console.log(res.data)
          this.payments = res.data
          this.pages = res.data.pages


        })
        .catch((err) => {
          console.log(err);
          if (err.message ===
            "Network Error") {
            this.$store.commit('snackbar', { color: 'red', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
          }
        })
        .finally(() => {
          this.$store.commit('progress_status', false)
        });
    },

    async check_payments(id) {
      this.$store.commit('progress_status', true)
      await axios({
        method: "GET",
        url: "/check-payment",
        headers: {
          token: sessionStorage.getItem("token")
        },
        params: {
          id
        }
      })
        .then((res) => {
          console.log(res.data)
          this.$store.commit('snackbar', { color: 'green', text: res.data })
          this.get_payments()
        })
        .catch((err) => {
          console.log(err);
          if (err.message ===
            "Network Error") {
            this.$store.commit('snackbar', { color: 'red', text: 'مشکلی در اتصال به اینترنت پیش آمده' })
          }
          this.$store.commit('snackbar', { color: 'red', text: err.response.data })

        })
        .finally(() => {
          this.$store.commit('progress_status', false)
        });
    },

    show_all() {
      this.company = ""
      this.user = ""
      this.authority = ""
      this.min_date = ""
      this.max_date = ""
      this.pay_type = ""
      this.status = ""
      this.get_payments()
    },

  }
};